import { UIRouter } from '@wix/tpa-router';
import type { ControllerParams } from '@wix/yoshi-flow-editor';

export function listenEditorPageChange(router: UIRouter, params: ControllerParams) {
    const { flowAPI } = params; 
    const { isEditor, isPreview } = flowAPI.environment;

    if (!isEditor && !isPreview) {
        return;
    }

    flowAPI.controllerConfig.wixCodeApi.location.onChange((data) => {
        // path: ['html', 'editor', 'web', 'renderer', 'render', 'document', '1f7eed2a-8764-4518-8703-274022cb4691', 'group', 'release-notes', 'discussion']
        const slug = data.path.length >= 10 ? data.path.at(-2) : undefined;

        if (slug) {
            router.stateService.go('group', { slug });
        }
    });
}

